import React from 'react'
import './Badge.css'

interface BadgeProps {
  label: string
  variant?: 'primary' | 'success' | 'warning' | 'danger' | 'info'
  size?: 'sm' | 'md'
  /** Full text to expose on hover when the label is visually truncated. */
  title?: string
}

export const Badge: React.FC<BadgeProps> = ({ label, variant = 'primary', size = 'md', title }) => {
  return (
    <span className={`badge badge--${variant} badge--${size}`} title={title ?? label}>
      {label}
    </span>
  )
}
